import {
  alertMessagesArgsConfig,
  boldSignDeliveryArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  expiryDaysArgsConfig,
  getItemIdFromArgsConfig,
} from '../../utils/event_constants';

export const boldSignActions = [
  {
    name: 'boldSignSendDocument',
    label: 'Send Document for Signature',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'pdfField', label: 'Select PDF Field' }),
      ...boldSignDeliveryArgsConfig,
      collectionFieldArgsConfig({ name: 'languageField', label: 'Language Field' }),
      ...getItemIdFromArgsConfig,
      expiryDaysArgsConfig,
      {
        name: 'fontSize',
        label: 'Signature Font Size (Min:7,Max:72)',
        type: 'number',
        value: '',
        min: 7,
        max: 72,
      },
      {
        name: 'signatureWidth',
        label: 'Signature Area Width (in pixels)',
        type: 'number',
        value: '',
      },
      {
        name: 'signatureHeight',
        label: 'Signature Area Height (in pixels)',
        type: 'number',
        value: '',
      },
      collectionFieldArgsConfig({
        name: 'documentReferenceField',
        label: 'Document Reference Field',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'boldSignDocumentStatus',
    label: 'Document Status',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'documentIdField', label: 'Select Document ID Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({ name: 'documentFileField', label: 'Save Document File Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'boldSignEmbeddedRequest',
    label: 'Embedded Request',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'titleField', label: 'Title Field' }),
      ...boldSignDeliveryArgsConfig,
      collectionFieldArgsConfig({ name: 'languageField', label: 'Language Field' }),
      ...getItemIdFromArgsConfig,
      expiryDaysArgsConfig,
      collectionFieldArgsConfig({ name: 'urlSaveField', label: 'Embedded Request URL Save Field' }),
      collectionFieldArgsConfig({
        name: 'documentReferenceField',
        label: 'Document Reference Field',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
];
